import { render, staticRenderFns } from "./widgetIpsecVpnTraffic.vue?vue&type=template&id=4861249a&scoped=true&"
import script from "./widgetIpsecVpnTraffic.vue?vue&type=script&lang=js&"
export * from "./widgetIpsecVpnTraffic.vue?vue&type=script&lang=js&"
import style0 from "./widgetIpsecVpnTraffic.vue?vue&type=style&index=0&id=4861249a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4861249a",
  null
  
)

export default component.exports